// `projects/shared/src/features/shared/interceptors/api-query-params.interceptor.ts`
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { QUERY_PARAM_CONFIGS } from '@nimbus-library/features/shared/models/api/query-params-configuration.model';

@Injectable()
export class ApiQueryParamsInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const queryParamConfig = QUERY_PARAM_CONFIGS.find(
      (config) => req.url.includes(config.urlSegment) && !req.params.has(config.queryParam),
    );
    if (queryParamConfig) {
      const params: HttpParams = req.params.set(queryParamConfig.queryParam, queryParamConfig.queryValue);
      return next.handle(req.clone({ params }));
    }
    return next.handle(req);
  }
}
